import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import GuideExplorer from "./components/GuideExplorer";
import Beginner from "./components/Beginner";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Navbar />
      <main>
        <Hero />
        <GuideExplorer />
        <Beginner />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}